<template>
  <div>
    <Row :gutter="8" class="mb-2">
      <i-col span="12">
        <!-- <div style="font-size: 14px">资产信息</div> -->
      </i-col>
      <i-col span="12" class="text-right">
        <a @click="handleChoiceDevice()">配置合同资产</a>
        <Divider type="vertical" />
        <a @click="handleChoiceSpace()">配置招商内容</a>
      </i-col>
        <i-col span="24">
          <Table :columns="datacolumns"  stripe size="small" show-summary  :summary-method="handleSummary"
            :data="contractResources"></Table>
        </i-col>
    </Row>

    <Row class="p-t-10">
      <i-col span="24">
        <Button type="info" @click="handlePreviousStep">上一步</Button>
        <div class="right">
          <Button type="info" @click="handleNextStep">下一步</Button>
        </div>
      </i-col>
    </Row>

    <rent-setting ref="rentSettingModal"></rent-setting>
    <choiceSpace
      ref="choiceSpaceModal"
      @on-success="initlistResourceAndFee"
      :contractId="contractInfo.id"
    ></choiceSpace>

    <choiceDevice
      ref="choiceDeviceModal"
      @on-success="initlistResourceAndFee"
      :contractId="contractInfo.id"
      :chkDeviceArray="chkDeviceArray"
    ></choiceDevice>

  </div>
</template>

<script>
import em from '@/utils/enum'
// import { getPositions } from '@/api/product/resource'
// import { addDevice, updateDevice } from '@/api/product/deviceedit'
import choiceSpace from './choiceSpace.vue'
import choiceDevice from './choiceDevice.vue'
import RentSetting from './RentSetting2.vue'
// utils
import Decimal from 'decimal.js'
/** new api */
import { listObjectAndFee, deleteObject, updateObjectNumber } from '@/api/invest/contract'

const MAX_CELL_ROW = 5

export default {
  components: { RentSetting, choiceSpace, choiceDevice },
  props: {},
  data () {
    return {
      dateUnitArray: em.dateUnitArray,

      contractResources: [],
      datacolumns: [
        { title: '编码', dataIndex: 'objectCode', key: 'objectCode' },
        { title: '站点', dataIndex: 'stationName', key: 'stationName' },
        { title: '类型', dataIndex: 'resourceTypeName', key: 'resourceTypeName' },
        {
          title: '计费数量',
          key: 'number',
          align: 'center',
          render: (h, params) => {
            let unit = ''
            if (params.row.objectType === 3007) {
              unit = ' 台'
            } else if ([3006, 3013].includes(params.row.objectType)) {
              unit = ' ㎡'
            }

            return h('div', [
              h('span', params.row.number + unit),
              h('Icon', {
                props: { type: 'ios-create-outline', size: 18, color: '#2d8cf0', id: 'editContentItemIon' },
                style: { 'margin-left': '4px', cursor: 'pointer' },
                on: {
                  click: (event) => {
                    this.updateContractItemNumber(params.row)
                  }
                }
              })
            ])
          }
        },
        {
          title: '计费周期',
          key: 'feeStartDate',
          align: 'center',
          width: '180',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.startDate + '至' + item.endDate
              ))
            })

            let showMore
            const tooMany = params.row.feeList.length > MAX_CELL_ROW
            const simple = tooMany ? resultStr.slice(0, MAX_CELL_ROW) : resultStr.slice(0)

            if (tooMany) {
              showMore = h(
                'a',
                {
                  on: {
                    click: () => {
                      params.row.showAll = !params.row.showAll
                    }
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: params.row.showAll
                        ? 'ios-arrow-down'
                        : 'ios-arrow-up',
                      color: '#4285f4',
                      size: 'large'
                    }
                  }),
                  h(
                    'span',
                    { style: { color: '#4285f4' } },
                    params.row.showAll ? '显示更多' : '隐藏'
                  )
                ]
              )
            }

            simple.push(showMore)
            resultStr.push(showMore)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费类型',
          key: 'feeTypeName',
          align: 'center',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.feeTypeName
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费单价',
          key: 'feeSignPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.signPrice + '元/' + this.formatDateUnit(item.dateUnit)
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '计费小计',
          key: 'feeMonthPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.monthPrice + '元/' + this.formatDateUnit(item.dateUnit)
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '合计费用',
          key: 'totalPrice',
          align: 'right',
          className: 'inverst-price-column-top',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.totalPrice
              ))
            })

            const simple = resultStr.slice(0, MAX_CELL_ROW)
            return h('div', params.row.showAll ? simple : resultStr)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 140,
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleRentSetting(params.row.id)
                  }
                }
              },
              '调整计费策略'
            )
            const deleteButton = h(
              'a',
              {
                style: {
                  marginRight: '5px',
                  color: '#ef4f4f'
                },
                on: {
                  click: () => {
                    this.handleDeleteItem(params.row)
                  }
                }
              },
              '删除'
            )

            return h('div', [detailButton, deleteButton])
          }
        }
      ]
    }
  },
  mounted () {},
  created () {
    this.initlistResourceAndFee()
  },
  methods: {
    formatDateUnit (type) {
      const unit = this.dateUnitArray.find(x => x.value === type)
      return unit ? unit.name : ''
    },
    initlistResourceAndFee () {
      const that = this
      listObjectAndFee({ contractId: that.contractInfo.id }).then((res) => {
        that.contractResources = res.map(x => {
          return Object.assign(x, { showAll: true })
        })
      })
    },
    handleSummary ({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 0) {
          sums[key] = {
            key,
            value: '总计'
          }
          return
        }

        if (key === 'totalPrice') {
          let total = 0
          data.forEach(element => {
            element.feeList.forEach(item => {
              total = Decimal.add(total, item.totalPrice).toNumber()
            })
          })

          sums[key] = {
            key,
            value: total
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })

      return sums
    },
    handleRentSetting (id) {
      this.$refs.rentSettingModal.showModal(this.contractResources, id)
    },
    handlePreviousStep () {
      this.$store.commit('set_contract_currentStep', 'basic')
      this.$store.commit('set_contract_update', new Date())
    },
    handleNextStep () {
      this.$store.commit('set_contract_currentStep', 'other')
      this.$store.commit('set_contract_update', new Date())
    },

    handleDeleteItem (item) {
      this.$Modal.confirm({
        title: '操作提示',
        content: `请问是否将编号为 ${item.objectCode} 从当前合同资产配置中移除吗？`,
        onOk: () => {
          deleteObject({ keyId: item.id }).then(res => {
            this.initlistResourceAndFee()
          })
        }
      })
    },

    // 配置招商内容
    handleChoiceSpace () {
      this.$refs.choiceSpaceModal.showModal()
    },
    // 配置资产
    handleChoiceDevice () {
      this.$refs.choiceDeviceModal.showModal()
    },
    updateContractItemNumber (item) {
      let updateNumber = item.number

      this.$Modal.confirm({
        title: '编辑计费数量',
        render: (h) => {
          return h('Input', {
            props: {
              value: updateNumber,
              autofocus: true,
              type: 'number',
              placeholder: '请填写新的计费数量'
            },
            on: {
              input: (val) => {
                updateNumber = val
              }
            }
          })
        },
        loading: true,
        onOk: () => {
          updateObjectNumber({
            keyId: item.id,
            number: updateNumber
          }).then((res) => {
            if (res && !res.errcode) {
              this.$Notice.success({ desc: '编辑计费数量成功！' })
              this.initlistResourceAndFee()
            }
            this.$Modal.remove()
          }).catch((error) => {
            this.$Modal.remove()
            this.$Notice.error({
              title: '服务器请求错误',
              desc: error
            })
          })
        }
      })
    }
  },
  watch: {
    beginUpdate () {
      this.initlistResourceAndFee()
    }
  },
  computed: {
    contractInfo () {
      return this.$store.state.investmentContract.contractInfo
    },
    beginUpdate () {
      return this.$store.state.investmentContract.beginUpdate
    },
    chkDeviceArray () {
      return this.contractResources.map(x => x.objectId)
    }
  }
}
</script>

<style>
.inverst-price-column-top{
  vertical-align: top !important;
}
</style>
